























import { defineComponent, ref, PropType, watch, toRefs } from '@vue/composition-api';
import {
  KeyTypeOptions,
  KeyInfoOptions,
  ResizeStrategyOptions,
  KeyType,
  KeyInfo,
  ResizeStrategy,
  CarouselImageSettingInfo,
} from '@tt4b/ttam-enums';
import Fields from './fields.vue';
import { useAllowlist } from '@tt4b/ttam-hooks';

const name = 'ttam-image-settings-enhancements-edit-modal';
export default defineComponent({
  name,
  components: {
    Fields,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    carouselImageInfo: {
      type: Object as PropType<CarouselImageSettingInfo>,
      default: () => ({
        keyType: KeyType.Disabled,
        keyInfo: KeyInfo.WithoutKeyInfo,
        resizeStrategy: ResizeStrategy.Original,
      }),
    },
  },
  setup(props, { emit }) {
    const { carouselImageInfo } = toRefs(props);
    const { isVSACarouselOptimizedImagesBackgroudWhite } = useAllowlist();

    const innerValue = ref({ ...carouselImageInfo.value });
    watch(carouselImageInfo, newValue => {
      innerValue.value = { ...newValue };
    });

    const onChange = (newValue: CarouselImageSettingInfo) => {
      innerValue.value = { ...newValue };
    };

    const handleSubmit = () => {
      emit('update:visible', false);
      emit('change', { ...innerValue.value });
    };

    const handleCancel = () => {
      emit('update:visible', false);
      innerValue.value = { ...carouselImageInfo.value };
    };

    return {
      name,
      innerValue,
      onChange,
      handleSubmit,
      handleCancel,
      KeyTypeOptions,
      KeyInfoOptions,
      ResizeStrategyOptions,
      isVSACarouselOptimizedImagesBackgroudWhite,
    };
  },
});
